// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '08d92a604a39954fb7afcad04a4ac728c46dd569';
export const BUILD_NUMBER = '192';
export const BUILD_TIMESTAMP = '2026-07-09T09:35:40.366Z';
